<template>
  <div>
    <div id="options-container" class="mt-2">
      <div
        :class="getSelectionStyle(PaymentMethod.bancolombia)"
        @click="selectStore(PaymentMethod.bancolombia)"
      >
        <img
          :src="`${useAsset('img/credit-line/bancolombia.png')}`"
          alt="BANCOLOMBIA"
        />
        <span class="ms-3">{{ t("BANCOLOMBIA") }}</span>
      </div>
      <div
        :class="getSelectionStyle(PaymentMethod.efecty)"
        @click="selectStore(PaymentMethod.efecty)"
      >
        <img :src="`${useAsset('img/credit-line/efecty.png')}`" alt="EFECTY" />
        <span class="ms-3">{{ t("EFECTY") }}</span>
      </div>
      <div
        :class="getSelectionStyle(PaymentMethod.refacil)"
        @click="selectStore(PaymentMethod.refacil)"
      >
        <img
          :src="`${useAsset('img/credit-line/refacil.png')}`"
          alt="REFACIL"
        />
        <span class="ms-3">{{ t("REFACIL") }}</span>
      </div>
      <div
        :class="getSelectionStyle(PaymentMethod.movii)"
        @click="selectStore(PaymentMethod.movii)"
      >
        <img :src="`${useAsset('img/credit-line/movii.png')}`" alt="MOVII" />
        <span class="ms-3">{{ t("MOVII") }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { PaymentMethod } from "@/apps/credit-line/types/payment";
import useAsset from "@/apps/credit-line/helpers/useAsset";

const { t } = useI18n();
const getSelectionStyle = inject("getSelectionStyle");
const selectStore = inject("selectStore");
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.green-option {
  background-color: $pj-color-green-hover;
  font-weight: bold;
  padding: 5%;
}

.regular-option {
  font-weight: bold;
  padding: 5%;
}
</style>
